















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { PolicyFundDto } from "@/api/ClientPortalApiClient";
import ApiFactory from "@/api/ApiFactory";

@Component
export default class PolicyFunds extends Vue {
  @Prop() policyId: number | undefined;
  @Prop() contactId: number | undefined;

  private funds: PolicyFundDto[] | null = null;

  async mounted() {
    await this.getFunds();
  }

  private async getFunds() {
    if (!this.policyId || !this.contactId)
      throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    this.funds = await api.funds_GetFunds(this.contactId, this.policyId);
  }

  get totalFundValue(): number {
    if (this.funds === null) return 0;
    let total = 0;
    this.funds.forEach(element => {
      total += element.value;
    });

    return total;
  }
}
